<template>
  <v-dialog v-model="visible" persistent max-width="480">
    <v-card>
      <v-card-title>Desativar localidade</v-card-title>
      <v-card-text>
        Tem certeza de que deseja desativar
        <strong>{{ place ? place.name : "" }}</strong>?
        Ela deixará de aparecer como opção nos novos cadastros.
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn text :disabled="loading" @click="visible = false">
          Cancelar
        </v-btn>
        <v-btn color="red" dark :loading="loading" @click="confirm">
          Desativar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { deletePlace } from "../../../services/places";

export default {
  name: "PlaceDeleteDialog",
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    place: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    visible: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
  methods: {
    async confirm() {
      if (!this.place || !this.place.id) return;

      this.loading = true;
      try {
        await deletePlace(this.place.id);
        this.$emit("deleted");
        this.visible = false;
      } catch (error) {
        this.$emit("error", error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
